export default __webpack_public_path__ + "static/media/vf-assigned-to-team.d64a7e0b.svg";